export const GALLERY_TYPE = Object.freeze({
  PROFILE: 'PROFILE',
  FANCLUB: 'FANCLUB',
  SAFE_FOR_WORK: 'SAFE_FOR_WORK',
  PUBLIC: 'PUBLIC',
  ALL: 'ALL',
});

export const USER_TYPE = {
  BROADCASTER: 'BROADCASTER',
  VIEWER: 'VIEWER',
};

export const USER_TYPE_INDEX = {
  ALL: 0,
  BROADCASTER: 1,
  VIEWER: 2,
};

export const APPROVAL_STATUS = {
  SFW: 'SFW',
  NSFW: 'NSFW',
  REJECTED: 'REJECTED',
};
